<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row :gutter="32">
                        <Col span="5">
                            <Card title="个人设置" icon="ios-options" :padding="0" bordered>
                                <CellGroup @on-click="checkMenu">
                                    <Cell name="userinfo" title="基本设置" :selected="active === 'userinfo'" label="个人账户基本信息设置" />
                                    <Cell name="pass" title="密码设置" :selected="active === 'pass'"  label="个人账户密码设置" />
                                    <Cell name="message" title="消息设置" :selected="active === 'message'"  label="各种通知消息设置" />
                                </CellGroup>
                            </Card>
                        </Col>
                        <Col span="10">
                            <template v-if="active === 'userinfo'">
                            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                                <FormItem label="用户昵称" prop="nick_name">
                                    <Input v-model="Forms.nick_name" placeholder="用户昵称"></Input>
                                </FormItem>
                                <FormItem label="真实姓名" prop="real_name">
                                    <Input v-model="Forms.real_name" placeholder="真实姓名"></Input>
                                </FormItem>
                                <FormItem label="性别" prop="sex">
                                    <RadioGroup v-model="Forms.sex">
                                        <Radio :label="1">先生</Radio>
                                        <Radio :label="2">女士</Radio>
                                    </RadioGroup>
                                </FormItem>
                                <FormItem label="手机号码" prop="mobile">
                                    <Input v-model="Forms.mobile" placeholder="手机号码"></Input>
                                </FormItem>
                                <FormItem label="微信账号" prop="wechat">
                                    <Input v-model="Forms.wechat" placeholder="微信账号"></Input>
                                </FormItem>
                                <FormItem label="电子邮箱" prop="email">
                                    <Input v-model="Forms.email" placeholder="电子邮箱"></Input>
                                </FormItem>
                                <FormItem label="收款账号" prop="account">
                                    <Input v-model="Forms.account" placeholder="用于报销常用收款账号"></Input>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" @click="FormSubmit()">保存资料</Button>
                                </FormItem>
                            </Form>
                            </template>
                            <template v-if="active === 'pass'">
                                <Form ref="FormsPass" :model="FormsPass" :rules="RulesPass"  label-position="top">
                                    <FormItem label="当前密码" prop="o_password">
                                        <Input type="password" v-model="FormsPass.o_password" placeholder="当前密码"></Input>
                                    </FormItem>
                                    <FormItem label="新的密码" prop="password">
                                        <Input type="password" v-model="FormsPass.password" placeholder="新的密码"></Input>
                                    </FormItem>
                                    <FormItem label="重复密码" prop="r_password">
                                        <Input type="password" v-model="FormsPass.r_password" placeholder="重复密码"></Input>
                                    </FormItem>
                                    <FormItem>
                                        <Button type="primary" @click="FormPassSubmit()">修改密码</Button>
                                    </FormItem>
                                </Form>
                            </template>
                            <template v-if="active === 'message'">
                                暂未开通
                            </template>
                        </Col>
                    </Row>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import {getUserInfo, savePass, saveUser} from "@/apis/user";
export default {
    name: "InfoIndex",
    components: {
        Headers, Side
    },
    data () {
        return {
            active: 'userinfo',

            Forms: {
                nick_name: '',
                real_name: '',
                sex: '',
                mobile: '',
                wechat: '',
                email: '',
                account: '',
            },
            Rules: {
                nick_name: [
                    { required: true, message: '请输入用户昵称', trigger: 'blur' }
                ],
                real_name: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                sex: [
                    { required: true, type:'number', message: '请选择性别', trigger: 'change',  transform(value) { return parseInt(value)} }
                ],
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ]
            },
            FormsPass: {
                o_password: '',
                password: '',
                r_password: ''
            },
            RulesPass: {
                o_password: [
                    { required: true, message: '请输入当前密码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入新的密码', trigger: 'blur' },
                    { type: 'string', min: 6,max:20, message: '密码长度必须为 6~20位', trigger: 'blur' }
                ],
                r_password: [
                    { required: true, message: '请重复输入密码', trigger: 'blur' },
                    { type: 'string', min: 6,max:20, message: '密码长度必须为 6~20位', trigger: 'blur' }
                ]
            }
        }
    },
    created(){
        this.GetUserinfo();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        checkMenu(e){
            let that = this;
            that.active = e;
        },
        GetUserinfo(){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getUserInfo().then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'sex') {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveUser(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                    })
                }
            })
        },
        FormPassSubmit(){
            let that = this;

            this.$refs['FormsPass'].validate((valid) => {
                if (valid) {
                    if(that.FormsPass.password !== that.FormsPass.r_password){
                        that.$Message.error({ background: true,duration:3, content:'两次输入的密码不一致'});
                        return;
                    }
                    that.$store.commit('SET_LOADING' , true);
                    savePass(that.FormsPass).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.$store.commit('SET_TOKEN' , '');
                        that.$store.commit('SET_USERINFO' , '');
                        that.$store.commit('SET_OPEN_NAMES' , 1);
                        that.$store.commit('SET_ACTIVE_NAMES' , 1);
                        that.$store.commit('SET_AUTH' , '');
                        that.$store.commit('SET_ROUTERS' , []);
                        that.$router.push({ path: '/login' })
                    })
                }
            })
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
